// ################################################### vikas ###################################################

// ############# Page sidebar Navigation  #############
const sidebarActive = () => {
    var url = window.location.href;
    var lastPathSegment = url.split("/").pop();

    // console.log(lastPathSegment);

    var page_Sidebar_items = document.querySelectorAll(".ps-items ul li");
    page_Sidebar_items.forEach((item, index) => {
        var page_Sidebar_items_text = item.children[0].getAttribute("href");
        // console.log(page_Sidebar_items_text);

        var lastPathSegmentSidebar = page_Sidebar_items_text.split("/").pop();
        // console.log(lastPathSegmentSidebar);

        if (lastPathSegment === lastPathSegmentSidebar) {
            item.classList.add("active");
        } else {
            item.classList.remove("active");
        }
    });
};
sidebarActive();

// addEventListener("load", function(event){});

// ############# Header Sticky  #############
$(document).ready(function () {
    if ($(window).width() > 899) {
        if ($(window).scrollTop() === 0) {
            $(".tb-c").hide();
        }
        $(window).scroll(function () {
            if ($(this).scrollTop() >= 10) {
                $(".header__heading, .header__heading-link ").slideUp("slow");
                $(".tb-c").slideDown("slow");
            } else {
                $(".header__heading, .header__heading-link ").slideDown("slow");

                $(".tb-c").slideUp("slow");
            }
        });

        $(".top-scroll img").click(function () {
            $("html, body").animate({ scrollTop: 60 }, "slow");
        });
    }
});

if ($(window).width() < 900) {
    let second_data = ` `;

    $(".top-bar-wrapper").after(second_data);

    $(".mob-user").click(function () {
        $(".image-content").slideToggle("slow");

        var currentImage = $(".mob-user img").attr("src");
        var newImage =
            currentImage ===
                "https://cdn.shopify.com/s/files/1/0815/5925/7422/files/img.png?v=1710409110"
                ? "https://cdn.shopify.com/s/files/1/0815/5925/7422/files/user-svg.svg?v=1709727297"
                : "https://cdn.shopify.com/s/files/1/0815/5925/7422/files/img.png?v=1710409110";

        $(".mob-user img").attr("src", newImage);
    });
}

// function loadafterreview() {
//     let pro_len = $(".js-recentPdpBlock .c-product").length;
//     console.log(pro_len);

//     if (pro_len > 4) {
//         $(".js-recentPdpBlock").slick({
//             slidesToShow: 4,
//             centerPadding: "center",
//             slidesToScroll: 1,
//         });
//     }
// }

// function loadafterreviewone() {
//     let pro_lenone = $(".js-recentPdpBlock .c-product").length;
//     console.log(pro_lenone);

//     if (pro_lenone > 3) {
//         $(".js-recentPdpBlock").slick({
//             slidesToShow: 3,
//             centerPadding: "center",
//             slidesToScroll: 1,
//             responsive: [
//                 {
//                     breakpoint: 768,
//                     settings: {
//                         slidesToShow: 2,
//                         slidesToScroll: 1,
//                     },
//                 },
//                 {
//                     breakpoint: 500,
//                     settings: {
//                         slidesToShow: 1,
//                         slidesToScroll: 1,
//                     },
//                 },
//             ],
//         });
//     }
// }


// $(document).ready(function () {
//     if ($(window).width() > 900) {
//         setTimeout(function () {
//             loadafterreview();
//         }, 2000);
//     } else {
//         setTimeout(function () {
//             loadafterreviewone();
//         }, 2000);
//     }

// });


setInterval(function () {
    let countIncElements = $('.countInc').length;

    if (countIncElements > 2) {
        let intervalId = setInterval(function () {
            function appendToGrids() {
                let gridItems = document.querySelectorAll('.countInc:last-child #product-grid .grid__item');
                gridItems.forEach((item, index) => {
                    let tempItem = item;
                    if (index <= 4) {
                        document.querySelector('.countInc:last-child #proWrapTwo').prepend(tempItem);
                    } else if (index >= 5 && index <= 9) {
                        document.querySelector('.countInc:last-child #proWrapOne').prepend(tempItem);
                    } else if (index >= 10 && index <= 15) {
                        document.querySelector('.countInc:last-child #proWrapThree').prepend(tempItem);
                    }
                });
            }
            appendToGrids();
            clearInterval(intervalId);
        }, 2000);
    }

})




// Mobile search function
// $(window).on('load', function(){
//     if ($(window).width() < 900) { 
//         let get_header_search = $('.header__search');
//         $('.mob-search-icon').append(get_header_search);
//     }

//     $('.details-modal.header__search').css({
//         "visibility": "visible",
//         "height": "auto"
//     });
// });


// Cart item count function (Fetch API)
//     fetch('/cart.js')
//         .then(response => {
//             if (!response.ok) {
//                 throw new Error('Network response was not ok');
//             }
//             return response.json();
//         })
//         .then(data => {
//             // Update item count with the latest data
//             item_count(data);
//         })
//         .catch(error => {
//             console.error('There was a problem with the fetch operation:', error);
//         });

//   function item_count(data) {
//     let item_count = data.item_count;
//     $('.items-count').text(item_count);
// }


// Cart item count (Ajax)
function updateCartCount() { 

    $.ajax({
        type: 'GET',
        url: '/cart.js',
        dataType: 'json',
        success: function (cartData) {
            $('.items-count').text(cartData.item_count);
        },
        error: function (XMLHttpRequest, textStatus, errorThrown) {
            console.log('Error loading cart Data: ' + errorThrown);
        }
    }); 

}
  updateCartCount();
$('.product-form__submit, .quick-add__submit, .add-size-wraper .product-form__submit').click(function() {
    setTimeout(updateCartCount, 2000);
});


// setInterval(updateCartCount, 10);

$(window).on('load', () => {
    $('.ana-product\\.looks .container-product .price').before('<hr>');
});

$('.product-controls .button--secondary ').click(function () {
    let position_looks = $('.container-product').offset().top - 220;
    $('html, body').animate({
        scrollTop: position_looks
    }, 1000);  
     
});

$('.product-form__submit').click(function() { 
   setTimeout(function(){ 
updateCartCount();
     }, 700)
    
})



// $(document).ready(function() {
//     let Product__Title = $('.product__title h1').text();

//     let looks_data = `
//         <div class="page-header phb phscroll">
//             <h3 class="look-hhsm">Productos del look <span class="xx">|</span> <span class="product_cur_title">${Product__Title}</span></h3>
//         </div>`;

//     $(window).on('load', function() {
//         $('.ana-product\\.looks .container-product').before(looks_data);
//     });
// });

$(document).ready(function () {
    let Product__Title = $('.product__title h1').text();

    let looks_data = `
          <div class="page-header phb phscroll">
              <h3 class="look-hhsm">Productos del look <span class="xx">|</span> <span class="product_cur_title">${Product__Title}</span></h3>
          </div>`;

    // let size_guide = 
    //   `
    //   <div class="widget-sizes" style="display: none;">
    //   <div class="close"><span aria-hidden="true">×</span></div>
    //   <div class="widget-sizes-inside">
    //     <div class="guide">
    //       <div class="guide-b">
    //         <h2><span>Guía de tallas mujer</span></h2>
    //       </div>
    //       <div class="guide-b">
    //         <h3>Ropa</h3>
    //         <table>
    //           <thead>
    //             <tr>
    //               <th class="cpl" colspan="2">TALLA</th>
    //               <th></th>
    //               <th></th>
    //               <th>34</th>

    //               <th>36</th>
    //               <th>38</th>
    //               <th>40</th>
    //               <th>42</th>
    //               <th>44</th>
    //               <th>46</th>
    //             </tr>
    //           </thead>
    //           <tbody>
    //             <tr>
    //               <td class="cpl" colspan="2">Pecho (cm)</td>
    //               <td></td>
    //               <td></td>
    //               <td>82</td>
    //               <td>86</td>
    //               <td>90</td>
    //               <td>94</td>
    //               <td>98</td>
    //               <td>102</td>
    //               <td>106</td>
    //             </tr>
    //             <tr>
    //               <td class="cpl" colspan="2">Cintura (cm)</td>
    //               <td></td>
    //               <td></td>
    //               <td>64</td>
    //               <td>66</td>
    //               <td>70</td>
    //               <td>74</td>
    //               <td>78</td>
    //               <td>82</td>
    //               <td>86</td>
    //             </tr>
    //             <tr>
    //               <td class="cpl" colspan="2">Cadera (cm)</td>
    //               <td></td>
    //               <td></td>
    //               <td>90</td>
    //               <td>94</td>
    //               <td>98</td>
    //               <td>102</td>
    //               <td>106</td>
    //               <td>110</td>
    //               <td>114</td>
    //             </tr>
    //           </tbody>
    //         </table>
    //       </div>
    //       <div class="guide-b">
    //         <table>
    //           <thead>
    //             <tr>
    //               <th class="cpl" colspan="2">TALLA</th>
    //               <th></th>
    //               <th></th>
    //               <th>XXS</th>
    //               <th>XS</th>
    //               <th>S</th>
    //               <th>M/85</th>
    //               <th>L/90</th>
    //               <th>XL</th>
    //             </tr>
    //           </thead>
    //           <tbody>
    //             <tr>
    //               <td class="cpl" colspan="2">Pecho (cm)</td>
    //               <td></td>
    //               <td></td>
    //               <td>80</td>
    //               <td>82</td>
    //               <td>86</td>
    //               <td>90</td>
    //               <td>96</td>
    //               <td>102</td>
    //             </tr>
    //             <tr>
    //               <td class="cpl" colspan="2">Cintura (cm)</td>
    //               <td></td>
    //               <td></td>
    //               <td>58</td>
    //               <td>62</td>
    //               <td>66</td>
    //               <td>70</td>
    //               <td>76</td>
    //               <td>82</td>
    //             </tr>
    //             <tr>
    //               <td class="cpl" colspan="2">Cadera (cm)</td>
    //               <td></td>
    //               <td></td>
    //               <td>86</td>
    //               <td>90</td>
    //               <td>94</td>
    //               <td>98</td>
    //               <td>104</td>
    //               <td>110</td>
    //             </tr>
    //           </tbody>
    //         </table>
    //       </div>
    //       <div class="guide-b">
    //         <h3>Medias y Leggins</h3>
    //         <table>
    //           <thead>
    //             <tr>
    //               <th class="cpl">TALLA</th>
    //               <th>S/M</th>
    //               <th>M/L</th>
    //             </tr>
    //           </thead>
    //           <tbody>
    //             <tr>
    //               <td class="cpl">Altura (cm)</td>
    //               <td>160-170</td>
    //               <td>165-180</td>
    //             </tr>
    //             <tr>
    //               <td class="cpl">Peso (cm)</td>
    //               <td>45-65</td>
    //               <td>55-80</td>
    //             </tr>
    //             <tr>
    //               <td class="cpl">Cadera (cm)</td>
    //               <td>94-98</td>
    //               <td>98-104</td>
    //             </tr>
    //           </tbody>
    //         </table>
    //       </div>
    //       <div class="guide-b">
    //         <h3>Anillos</h3>
    //         <table>
    //           <thead>
    //             <tr>
    //               <th class="cpl">TALLA</th>
    //               <th>S</th>
    //               <th>M</th>
    //               <th>L</th>
    //             </tr>
    //           </thead>
    //           <tbody>
    //             <tr>
    //               <td class="cpl">Diámetro (mm)</td>
    //               <td>16.5</td>
    //               <td>17.5</td>
    //               <td>18.5</td>
    //             </tr>
    //           </tbody>
    //         </table>
    //       </div>
    //       <div class="guide-extra">
    //         <h3>Calzado</h3>
    //         <table>
    //           <thead>
    //             <tr>
    //               <th class="cpl" colspan="2">TALLA</th>
    //               <th></th>
    //               <th></th>
    //               <th>35</th>
    //               <th>36</th>
    //               <th>37</th>
    //               <th>38</th>
    //               <th>39</th>
    //               <th>40</th>
    //               <th>41</th>
    //               <th>42</th>
    //             </tr>
    //           </thead>
    //           <tbody>
    //             <tr>
    //               <td class="cpl" colspan="2">Longitud pie (cm)</td>
    //               <td></td>
    //               <td></td>
    //               <td>22.35</td>
    //               <td>22.99</td>
    //               <td>23.63</td>
    //               <td>24.27</td>
    //               <td>24.27</td>
    //               <td>25.54</td>
    //               <td>26.18</td>
    //               <td>26.82</td>
    //             </tr>
    //           </tbody>
    //         </table>
    //       </div>
    //       <div class="guide-extra">
    //         <table>
    //           <thead>
    //             <tr>
    //               <th class="cpl">TALLA</th>
    //               <th>36/37</th>
    //               <th>38/39</th>
    //               <th>40/41</th>
    //             </tr>
    //           </thead>
    //           <tbody>
    //             <tr>
    //               <td class="cpl">Longitud pie (cm)</td>
    //               <td>22.63</td>
    //               <td>24.90</td>
    //               <td>26.18</td>
    //             </tr>
    //           </tbody>
    //         </table>
    //       </div>
    //     </div>
    //     <div class="guide-image">
    //       <h2><span>Cómo medir</span></h2>
    //       <img src="https://bigcommercemasters.com/anna/app/layout/imgs/sizes.png">
    //     </div>
    //   </div>
    // </div>
    //   `;

    $(window).on('load', function () {
        $(looks_data).insertBefore('.ana-product\\.looks .container-product');
        // $(size_guide).insertBefore('.ana-product\\.looks .page-header');
    });
});


function scroll_top() {
    let product_scroll = `
          <div class="page-scroll-top">
             <div class="top-scroll">
                <img src="https://cdn.shopify.com/s/files/1/0815/5925/7422/files/boton_subir_1.png" alt="top scroll page">
             </div>
          </div>`;
    $(product_scroll).insertAfter('.ana-product\\.looks #MainContent');

    $('.page-scroll-top').click(() => {
        $('html, body').animate({
            scrollTop: 50
        }, 1000);
    });
}

$(window).on('load', scroll_top);

$(window).on('load', () => {
    $(' .ana-product\\.looks .variants .variant_item:first-child').addClass('active_checked');

    $('.looks-pannel-group .product-item').each(function (index, item) {
        var $variantItems = $(item).find('.variant_item');

        $variantItems.click(function () {
            // Remove active_checked class from sibling variant items
            $variantItems.not(this).removeClass('active_checked');
            // Add active_checked class to the clicked variant item
            $(this).addClass('active_checked');
        });
    });


    // $(' .ana-product\\.looks .variants .variant_item').click(function() {
    //     $(' .ana-product\\.looks .variants .variant_item').removeClass('active_checked');
    //     $(this).addClass('active_checked');
    // });
});



$('#product_size').click(function () {
    $('.looks-close').trigger('click')

    let postion_looks = $('.ana-product\\.looks .widget-sizes').offset().top + 1000;

    $('.widget-sizes').slideToggle('slow');

    $('html, body').animate({
        scrollTop: postion_looks
    }, 1000);
});
$(' .ana-product\\.looks .widget-sizes .close').click(function () {
    $(' .ana-product\\.looks .widget-sizes').slideUp('slow')
})



// $(window).on('load', () => {
//     if ($(window).width() >  900 && $('.related-products .product-grid').length) {
//         setTimeout(function() {
//             $('.related-products .product-grid').slick({
//                 dots: false,
//                 infinite: true,
//                 arrows: false,
//                 autoplay:true,
//                 speed: 300,
//                 slidesToShow: 3, 
//                 slidesToScroll: 1, 
//                 responsive: [
//                    {
//                         breakpoint: 767, 
//                         settings: {
//                             slidesToShow: 2,
//                             slidesToScroll: 1
//                         }
//                     },
//                     {
//                         breakpoint: 500, 
//                         settings: {
//                             slidesToShow: 1,
//                             slidesToScroll: 1
//                         }
//                     }
//                 ]
//             });

//           $('.related-products li.grid__item').css({
//             "margin": "0 5px"
//           });
//         }, 2000);
//     }
//     else if ($(window).width() < 899 && $('.related-products .product-grid').length) {
//          $('.related-products .product-grid').slick({
//                 dots: false,
//                 infinite: true,
//                 arrows: false,
//                 autoplay:true,
//                 speed: 300,
//                 slidesToShow: 3, 
//                 slidesToScroll: 1, 
//                 responsive: [
//                    {
//                         breakpoint: 767, 
//                         settings: {
//                             slidesToShow: 2,
//                             slidesToScroll: 1
//                         }
//                     },
//                     {
//                         breakpoint: 500, 
//                         settings: {
//                             slidesToShow: 1,
//                             slidesToScroll: 1
//                         }
//                     }
//                 ]
//             });
//     }
// });


function relatedProducts(){
  setTimeout(function(){
    if( $('.related-products .grid__item').length){
        $('.related-products .product-grid').slick({
            dots: false,
            infinite: true,
            arrows: true,
            autoplay:false,
            speed: 300,
            slidesToShow: 4, 
            slidesToScroll: 1, 
            responsive: [
               {
                    breakpoint: 1024, 
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 767, 
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 500, 
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });

    }
  }, 2000);
}
$(window).on('load', ()=>{

  if($(window).width() > 900){
    relatedProducts();
  }else{
    relatedProducts();
  }
    

  
  
});


const firstLi = document.querySelector('.mega-menu__list li:first-child');

if (firstLi) {

    const aTags = firstLi.querySelectorAll('a');


    aTags.forEach(a => {
        a.href = "javascript:void(0);";
        a.style.pointerEvents = "none"; 
        a.style.cursor = "initial"; 
    });
}

// ################################################### End ###################################################
